// selectors

export const getMyRecipes = state => {
  return state.MyRecipes.myRecipes.list;
};

export const getMyRecipesPagination = state => {
  return state.MyRecipes.myRecipes.pagination;
};
